module.exports = __webpack_public_path__ + "9d29ab2d69250625484425f189590312.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/images/navigators/ic-section-token.svg
// module id = 1498
// module chunks = 3